import React from "react";
import bannerImage from "assets/images/banner-img.svg";
import bannerImage2 from "assets/images/banner-img-2.svg";
import bannerImage3 from "assets/images/banner-img-3.svg";
import greenTick from "assets/images/green-tick.png";
import OwlCarousel from "react-owl-carousel";

const content = [
  {
    title: "The most prominent",
    titleSpan: "Gig work platform for enterprises",
    endTitle: "in India.",
    subtitle:
      "India’s leading gig work platform for enterprise-level tasks.",
    description:
      "We simplify intricate business requirements by breaking them down into manageable tasks, and we assume full responsibility for executing the entire scope of the work.",
    descPoints: [
      { point: "Pay for deliverables/outcomes" },
      { point: "Variable and on-demand capabilities" },
      { point: "Real-time tracking and updates" },
    ],
    isButton: true,
    image: bannerImage,
  },

  {
    title: "A vast ",
    titleSpan: "network of over a million skilled",
    endTitle: "gig workers.",
    description:
      "A diverse workforce community primed for immediate deployment. We uphold stringent quality standards through rigorous selection, training, and onboarding to meet your SLAs.",
    descPoints: [
      { point: "500+ cities & 13,000+ Pin codes" },
      { point: "Blue, grey, and white-collar profiles" },
      { point: "Across 15+ vernacular languages" },
    ],
    isButton: false,
    image: bannerImage2,
  },

  {
    title: "A technology",
    titleSpan: "platform that operates",
    endTitle: "without the need for coding.",
    description:
      "An entirely customizable technology stack designed to transform and execute even the most complex workflows, tailored precisely to meet your unique business requirements.",
    descPoints: [
      { point: "Execution app for gig workers" },
      { point: "War Room for Pehal PM Team" },
      { point: "Client Dashboard for Enterprises" },
    ],
    isButton: false,
    image: bannerImage3,
  },
];

const HomeContent = () => {
  const scrollToRegister = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: yOffset, behavior: "smooth" });
    }
  };

  const options = {
    items: 1,
    margin: 30,
    dots: false,
    nav: true,
    smartSpeed: 2000,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    loop: true,
    responsiveClass: true,
    vertical: true,
    // autoplay: true,
    // autoplayTimeout: 3000,
  };

  return (
    <>
      <section className="section home-banner row-middle">
        <div className="main-content">
          <div className="container" style={{ paddingTop: "50px" }}>
            <OwlCarousel
              id="developers-slider"
              className="owl-carousel owl-theme developers-slider aos"
              loop
              {...options}
            >
              {content?.map((x, i) => {
                return (
                  <React.Fragment key={i}>
                    <div className="row align-items-center">
                      <div className="col-md-8 col-lg-7">
                        <div className="home-content aos" data-aos="fade-up">
                          <h1>
                            {x?.title}{" "}
                            {x?.titleSpan && <span>{x?.titleSpan}</span>}{" "}
                            {x?.endTitle}
                          </h1>
                          {x?.subtitle && <h3>{x?.subtitle}</h3>}
                          <p>{x?.description}</p>
                          {!!x?.descPoints?.length &&
                            x?.descPoints?.map((y) => {
                              return (
                                <div className="home-points mb-2">
                                  <div className="d-flex align-items-center">
                                    <img src={greenTick} alt="" />
                                    <p>{y?.point}</p>
                                  </div>
                                </div>
                              );
                            })}
                          {x?.isButton && (
                            <button
                              className="btn-pehal mt-2"
                              type="button"
                              onClick={() => scrollToRegister("register")}
                            >
                              Pehal Client
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-5">
                        <img src={x?.image} alt="" className="w-100" />
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeContent;
